import { render, staticRenderFns } from "./violation-item.vue?vue&type=template&id=762d5b4c"
import script from "./violation-item.vue?vue&type=script&lang=js"
export * from "./violation-item.vue?vue&type=script&lang=js"
import style0 from "./violation-item.vue?vue&type=style&index=0&id=762d5b4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports